export const customColors = {
  darkGray: '#404040',
  mediumGray: '#666666',
  lightGray: '#e0e0e0'
};
